import { useLingui } from "@lingui/react/macro";
import { formatDate } from "@offstreetparking/design-system/formatters";
import { useLocale } from "@offstreetparking/design-system/providers";
import { Text } from "@offstreetparking/design-system/typography";
import { type ProrationInterval, getProration } from "./getProration";

type ProrationInfoBannerProps = {
	fullTermIntervals?: ProrationInterval[];
	timezone?: string;
};

export const ProrationInfoBanner = ({ fullTermIntervals, timezone }: ProrationInfoBannerProps) => {
	const { t } = useLingui();
	const { locale } = useLocale();
	const proration = getProration({ fixedIntervals: fullTermIntervals, timezone });
	if (!proration.isProrated || !proration.fullTermStartISO || !proration.fullTermEndISO || !timezone) {
		return null;
	}
	const fullTermStart = formatDate({
		date: proration.fullTermStartISO,
		formatType: "Abbreviated_Date",
		timezone,
		language: locale,
	});
	const fullTermEnd = formatDate({
		date: proration.fullTermEndISO,
		formatType: "Abbreviated_Date",
		timezone,
		language: locale,
	});
	return (
		<div className="rounded-md bg-primary-faded p-3">
			<Text size="sm">
				{t`Full permit term is ${fullTermStart} – ${fullTermEnd}. Your price is prorated based on the remaining permit term.`}
			</Text>
		</div>
	);
};
